
<template>
  <div class="home-list" :class="$store.state.theme">
    <div v-if="lists.length" class="wrapper">
      <div class="list-title">{{ listTitle }}</div>
      <div class="btns single-line no-scrollbar gpu-accelerated">
        <div class="list-padding" />
        <div v-for="(b, i) in buttons" :key="i + b.name" class="btn" @click="handleAction(b)">
          <div v-if="b.pic">
            <!-- <img :src="langPic(b)" height="135px" width="246px" /> -->
            <!-- <img :src="langPic(b)" height="120px" width="218px" /> -->
            <!-- <img :src="langPic(b)" height="120px" /> -->
            <img v-webp="langPic(b)" height="120px" />
          </div>
          <div v-else>
            <i>{{ b.name }}</i>
            <img :src="$store.state.errorProfilePic" />
          </div>
          <div v-if="hasNames" class="label">
            <span v-if="b.show_name">{{ b.name }}</span>
            <span v-else>&nbsp;</span>
          </div>
        </div>
        <div class="list-padding" />
      </div>
    </div>
    <!-- <div v-else>None</div> -->
  </div>
</template>


<script>
// import vehicles from "@/vehicles";

export default {
  name: "HomeList",
  props: {
    list: String,
    // title: String,
  },
  data() {
    return {
      lists: [],
      title: null,
      imgFallback: {
        loading: this.$store.state.menuItemPlaceholderPic, //birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
      z: 0,
    };
  },
  computed: {
    listTitle() {
      if (!this.title) return `Home_${this.list}`;
      return this.title.data.title[this.lang] || this.title.data.title.en;
    },
    lang() {
      return this.$store.state.language;
    },
    hasNames() {
      return this.buttons.find((b) => b.show_name);
    },
    buttons() {
      console.log("update buttons", this.z);
      return this.lists
        .filter((l) => !l.data.hidden)
        .map((l) => {
          return l.data;
        });
    },
    promoButtons() {
      return [
        {
          text: this.$t("promos.aircon-service"),
          img: "/img/home2/air-conditioner.svg",
          action: "goto",
          link: "/shop/7252a5ee-8167-11ea-b937-e60faa921629",
        },
        {
          text: this.$t("promos.restaurant-discounts"),
          img: "/img/home2/gift.svg",
          action: "goto",
          link: "/eat?s=_promo",
        }, // link: "/eat?s=*free-delivery",
      ];
    },
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      // if (mutation.type === "setLanguage") this.z += 1; // update images on lang change
      if (mutation.type === "setRegion") this.getBlobs(); //this.z += 1; // update images on lang change
    });
  },
  activated() {
    this.getBlobs();
  },
  methods: {
    shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
    },
    langPic(b) {
      var key = `pic_${this.lang}`; // pic_en, pic_th etc
      return b[key] || b.pic; // default if lang pic doesn't exist
    },
    handleAction(b) {
      console.log("handleAction goto:", b.tag);
      //   this.infoToast(`goto ${b.tag}`);
      if (b.tag.includes("http")) {
        window.open(b.tag, "_target");
      } else {
        this.goto(b.tag);
      }
    },
    invalidTimeForList(timeSlot) {
      var now = this.$date.getHHMM();
      var start = parseInt(timeSlot.start);
      var stop = parseInt(timeSlot.end);
      if (stop == 0) stop = 2400;
      return now < start || now > stop;
    },
    getBlobs() {
      var page = `Home_${this.list}`;
      var region = this.$store.state.region || "Chiang Mai"; // assume Chiang Mai if region not set for now
      // TODO use any visited business as region fallback
      var pageRegion = { page: page, region: region };
      this.$store
        .dispatch("getBlobsForList", pageRegion)
        .then((res) => {
          if (!res.data) {
            this.lists = [];
            return;
          }
          this.lists = res.data.filter((o) => o.blob_type === "list");
          // remove any hidden lists here so we don't check if open
          this.lists = this.lists.filter(l => !l.data.hidden)
          this.title = res.data.find((o) => o.blob_type === "list_title");
          if (this.title && this.title.data.settings) {
            var settings = this.title.data.settings;
            if (settings.randomise) {
              this.shuffleArray(this.lists);
              console.log("shuffle list", this.title.data);
            }
            if (settings.time_slot) {
              if (this.invalidTimeForList(settings.time_slot)) {
                this.lists = [];
                console.log("time slot hide list", this.title.data);
              }
            }
            if (settings.shop_open) {
              // console.log("TODO check if shops open");
              this.checkShopsOpenBulk();
              this.checkShopsOpen();
            }
            if (settings.hidden) {
              this.lists = [];
              console.log("hidden list", this.title.data);
            }
          }
          // console.log(`getBlobs page/region ${page}/${region}`, this.lists);
        })
        .catch((err) => console.error("getBlobs page:Home region:cm", err));
    },
    checkShopsOpenBulk() {
      // instead of 10+ separate API calls per list
      var handles = [];
      this.lists.forEach((l) => {
        var handle = l.data.tag.split("?")[0];
        if (handle.includes("@")) handles.push(handle)
      });
      console.log("checkShopsOpenBulk", handles);
      // this.$store
      //   .dispatch("areShopsOpen", handles)
      //   .then((res) => {
      //     console.log("checkShopsOpenBulk", res.data);
      //     // this.z += 1;
      //   })
      //   .catch((err) => console.error(err));
    },
    checkShopsOpen() {
      this.lists.forEach((l) => {
        var handle = l.data.tag.split("?")[0];
        if (!handle.includes("@")) {
          console.log("skip shop open check: " + handle);
          return;
        }
        this.$store
          .dispatch("isShopOpen", handle)
          .then((res) => {
            if (res.data === "yes") {
              console.log(`-- ${handle} : OPEN : ${res.data}`);
            } else {
              l.data.hidden = true;
              console.log(`-- ${handle} : NOT OPEN : ${res.data}`);
            }
          })
          .catch(() => {
            l.data.hidden = true;
            console.log(`-- ${handle} : NOT OPEN`);
            this.z += 1; // hides this shop
          });
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
  width: calc(100% + 80px);
  left: -40px;
  margin-top: 20px;
  /* overflow-y: hidden; */
}

.list-title {
  text-align: left;
  /* margin-left: 24px; */
  margin-left: 20px;
  margin-bottom: 0;
  opacity: 0.75;
  font-weight: 550;
  /* font-size: 0.9em; */
  font-size: 1.2em;
}

.single-line {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: -10px;
  /* display: inline-block; */
}

.btns {
  /* padding-left: 20px; */
  margin-bottom: 4px;
  /* width: 100vw; */
  /* width: 100%; */
  /* display: inline-block; */
  /* margin-top: 10px; */
  font-size: 0.85em;
  /* font-weight: 450; */
  text-align: left;
}

.btn {
  display: inline-block;
  margin-top: 10px;
  margin: 4px;
  /* height: 90px; */
  /* height: 135px; */
  height: 120px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 3px;
  /* box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05); */
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.06);
}

.btn i {
  position: absolute;
  width: 120px;
  background-color: rgba(255, 255, 255, 0.8);
  color: #444;
  border-radius: 3px;
  padding: 0 3px;
  white-space: initial;
}

img {
  border-radius: 3px;
  object-fit: cover;
  /* height: 90px; */
  /* height: 135px; */
  height: 120px;
  max-width: 218px;
  /* box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.05); */
}

.dark .btn {
  background-color: rgba(17, 34, 51, 0.8);
  color: white;
}

.dark .list-title,
.dark p,
.dark .label {
  color: white;
}

.list-padding {
  display: inline-block;
  width: 16px;
}

.label {
  margin-left: 7px;
  font-size: 1em;
  height: 30px;
  max-width: 100px;
  text-overflow: ellipsis;
}
</style>